import * as React from 'react';

import { createReactRenderer } from 'helpers/react-renderer';
import { ScanDataProvider } from 'root/apps/InventoryCountScanQueue/context/ScanData';

import ScanQueueButton from './views/ScanQueueButton';

interface Props {
  inventoryCountID?: string;
}

const InventoryCountScanQueue: React.FC<Props> = ({ inventoryCountID }) => {
  const { id: accountId } = window.merchantos.account;
  const employeeID = window.merchantos.session.getEmployee()?.employeeID;

  if (!inventoryCountID || !accountId || !employeeID) {
    return null;
  }

  return (
    <ScanDataProvider
      inventoryCountID={inventoryCountID!}
      accountID={accountId}
      employeeID={employeeID}
    >
      <ScanQueueButton isOpen={false} />
    </ScanDataProvider>
  );
};

const RenderedComponent = createReactRenderer({
  component: InventoryCountScanQueue,
  selector: '[data-react-root="InventoryCountScanQueue"]',
});

export default InventoryCountScanQueue;

history.onChangeState(
  [
    {
      name: ['inventory_count.views.inventory_count'],
      form_name: 'view',
      tab: 'count',
      id: undefined,
    },
  ],
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);
